import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import EventOutlinedIcon from '@mui/icons-material/EventOutlined'
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined'
import PhoneCallbackOutlinedIcon from '@mui/icons-material/PhoneCallbackOutlined'
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined'
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined'
import type { ProspectoDTO } from '../../../model/kartera-api-model'
import { labelize } from '../../customers/common/customer-common'
import type { NoteMeta, NoteType } from '../../customers/common/customer-common'

export {
    AVATAR_TONES,
    BITACORA_FILTERS,
    chipClass,
    errorMessage,
    fiscalLabel,
    formatActivityDate,
    formatCount,
    formatSpokenDate,
    formatWithAge,
    initials,
    isMoral,
    labelize,
    pageWindow,
    personName,
    phoneHref,
    statusKey,
} from '../../customers/common/customer-common'
export type { BitacoraFilter, NoteMeta, NoteType } from '../../customers/common/customer-common'

export const PROSPECTS_PATH = '/prospectos'

export const editProspectLocation = (id: number, backUrl = PROSPECTS_PATH) => ({
    pathname: `${PROSPECTS_PATH}/${id}/edit`,
    state: { backUrl },
})

export const NOTE_TYPES: NoteType[] = [
    { id: 'nota general', label: 'Nota', filter: 'nota', Icon: StickyNote2OutlinedIcon, tone: 'bg-tone-purple text-tone-purple-ink', placeholder: 'Escribe una nota interna…' },
    { id: 'llamada saliente', label: 'Llamada', filter: 'llamada', Icon: PhoneOutlinedIcon, tone: 'bg-tone-teal text-tone-teal-ink', placeholder: '¿De qué hablaron en la llamada?' },
    { id: 'llamada entrante', label: 'Recibida', filter: 'llamada', Icon: PhoneCallbackOutlinedIcon, tone: 'bg-tone-teal text-tone-teal-ink', placeholder: '¿Qué te comentaron en la llamada?' },
    { id: 'correo', label: 'Correo', filter: 'correo', Icon: EmailOutlinedIcon, tone: 'bg-tone-blue text-tone-blue-ink', placeholder: 'Resumen del correo enviado o recibido…' },
    { id: 'platica con humano', label: 'Reunión', filter: 'reunion', Icon: EventOutlinedIcon, tone: 'bg-tone-orange text-tone-orange-ink', placeholder: 'Acuerdos de la reunión…' },
]

export const noteMeta = (tipo?: string | null): NoteMeta => {
    const known = NOTE_TYPES.find((item) => item.id === tipo)
    if (known) return known
    if (tipo === 'adjunto') return { label: 'Adjunto', filter: 'otro', Icon: AttachFileOutlinedIcon, tone: 'bg-tone-pink text-tone-pink-ink' }
    return { label: labelize(tipo) || 'Registro', filter: 'otro', Icon: ForumOutlinedIcon, tone: 'bg-tone-pink text-tone-pink-ink' }
}

export const prospectContact = (prospecto?: Pick<ProspectoDTO, 'email' | 'telefono'> | null) => ({
    email: String(prospecto?.email || '').trim(),
    phone: String(prospecto?.telefono || '').trim(),
})
